import Image from "../../../../../components/elements/Image";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Input from "../../../../../components/form/Input";
import Checkbox from "../../../../../components/form/Checkbox";
import Button from "../../../../../components/form/Button";
import EventBG from "../../../../../assets/images/event-list.webp";
import useForm from "../../../../../hooks/useForm";
import { useMutation } from "@tanstack/react-query";
import {
  authLogin,
  otpVerification,
  sendOtp,
} from "../../../../../services/authService";
import { toast } from "react-toastify";
import { login } from "../../../../../redux/slice/authSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import OtpInput from "../../../../../components/form/OtpInput";
import { apiRequest } from "../../../../../util/apiUtils";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const { lang } = useSelector((state) => state?.langProvider);
  const location = useLocation();
  const navigate = useNavigate();

  const validation = {
    ...(!location?.state?.email && {
      email: { required: true, message: "Please enter your email!" },
    }),
    ...(location?.state?.email &&
      location?.state?.mode === "otp" && {
        otp: { required: true, message: "Please enter otp!" },
        newPassword: { required: true, message: "Please enter new password!" },
        confirmPassword: {
          required: true,
          message: "Please enter confirm password!",
        },
      }),
  };

  const { values, handleChange, handleSubmit, errors, formValidate } = useForm({
    validationRules: validation,
  });

  const {
    mutate: forgetPassword,
    data,
    isPending,
  } = useMutation({
    mutationFn: async (val) => {
      // this is use for 1st layout when provide email first
      if (!location?.state?.email) {
        return await sendOtp({
          requestType: "RESETPASSWORD",
          email: val?.email,
        });
      }
      // after send otp ================> 👇
      if (location?.state?.email && location?.state?.mode === "otp") {
        const res = await apiRequest("post", "reset-password", {
          body: {
            email: location?.state?.email,
            otp: val?.otp,
            newPassword: val?.newPassword,
            confirmPassword: val?.confirmPassword,
          },
        });
        return res?.data;
      }
    },
    onSuccess: (res) => {
      if (res?.status === 200) {
        if (!location?.state?.email) {
          navigate("/forgot-password", {
            state: { email: res?.data?.email, mode: "otp" },
          });
        } else {
          toast.success(res?.message);
          navigate("/");
        }
      } else {
        toast.error(res?.message || res?.error);
      }
    },
  });

  return (
    <div className="flex items-center justify-center bg-gradient-to-br from-[#F9F6FF] to-[#F4F1FD] p-6  relative">
      <div className="p-2 border-2 border-white rounded-4xl overflow-hidden max-w-6xl w-full">
        <div className="grid grid-cols-12  bg-white rounded-4xl overflow-hidden">
          <div className="col-span-6 py-14 px-20 flex flex-col justify-center">
            <Link
              to="/"
              className="w-48 overflow-hidden aspect-[7/1] block mb-5"
            >
              <Image
                src={require("../../../../../assets/images/logo.png")}
                classes={"object-contain"}
              />
            </Link>
            <h1 className="text-2xl font-bold text-deep-purple mb-1">
              Welcome! What's your email?
            </h1>
            <div className="text-slate-500 mb-5">
              Fill the below form to change password
            </div>
            <form
              className="space-y-6"
              onSubmit={(event) => handleSubmit(event, forgetPassword)}
            >
              <div className="relative">
                {location?.state?.email && location?.state?.mode === "otp" && (
                  <>
                    {location?.state?.email && (
                      <div className="relative flex gap-2 items-center">
                        <h4 className="font-bold text-base">Email:</h4>{" "}
                        <p className="text-sm">{location?.state?.email}</p>
                      </div>
                    )}
                    <OtpInput
                      label={"Enter the secure code from your email"}
                      handleOtpChange={(val) =>
                        handleChange({
                          target: { value: val, name: "otp" },
                        })
                      }
                      inputName="otp"
                      labelChildClass={
                        "!h-12 !rounded-lg !border-white !bg-transparent !text-deep-purple focus:!border-primary"
                      }
                      {...formValidate(errors, "otp")}
                    />
                    <Input
                      label="Password"
                      labelClasses="!text-base capitalize"
                      inputType="password"
                      inputClasses={"h-14 focus:!border-primary"}
                      inputName={"newPassword"}
                      value={values?.newPassword}
                      onChange={handleChange}
                      {...formValidate(errors, "newPassword")}
                    />
                    <Input
                      label="Confirm Password"
                      labelClasses="!text-base capitalize"
                      inputType="password"
                      inputClasses={"h-14 focus:!border-primary"}
                      inputName={"confirmPassword"}
                      value={values?.confirmPassword}
                      onChange={handleChange}
                      {...formValidate(errors, "confirmPassword")}
                    />
                  </>
                )}
                {!location?.state?.email && (
                  <Input
                    label="email"
                    labelClasses="!text-base capitalize"
                    inputType="email"
                    inputClasses={"h-14 focus:!border-primary"}
                    inputName={"email"}
                    value={values?.email}
                    onChange={handleChange}
                    {...formValidate(errors, "email")}
                  />
                )}
              </div>
              <div className="relative">
                <Button
                  buttonType="submit"
                  buttonIconPosition={"left"}
                  buttonIcon={"fa-regular fa-arrow-right"}
                  buttonLabel={
                    !location?.state?.email
                      ? "Send Otp"
                      : location?.state?.mode === "otp" && "Reset Password"
                  }
                  buttonLabelClasses="capitalize"
                  {...(isPending && {
                    loading: true,
                    buttonIconPosition: "left",
                    isDisable: true,
                  })}
                />
              </div>
            </form>
            <div className="mt-5 text-slate-500 text-sm">
              Don’t have an account?{" "}
              <Link
                to="/register"
                className="text-deep-purple hover:underline font-medium"
              >
                Sign up
              </Link>
            </div>
          </div>
          <div className="col-span-6 pt-5 pr-5 pb-5 pl-0">
            <div className="space-y-5 rounded-2xl overflow-hidden bg-gradient-to-br from-[#F9F6FF] to-[#F4F1FD] py-14 pl-10 flex flex-col w-full">
              <div className="capitalize text-slate-500 text-xs bg-white border border-text-disabled rounded-md p-1 max-w-60 text-center flex items-center justify-center">
                dancebrite system pressure control
              </div>
              <div className="text-slate-500 font-medium text-base max-w-96 w-full">
                Manage your concreting and construction operation{" "}
                <span className="text-deep-purple0">more professionally</span>
              </div>
              <div className="w-full aspect-[5/4] overflow-hidden">
                <Image src={EventBG} classes={"object-cover"} />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-decoration bg-decoration-1"></div>
      <div className="bg-decoration bg-decoration-2"></div>
      <div className="bg-decoration bg-decoration-3"></div>
    </div>
  );
};

export default ForgotPassword;
